import React from 'react';
import { Elements, StripeProvider } from 'react-stripe-elements';

const Stripe = ({ children }) =>
  <StripeProvider apiKey={ process.env.SRIPE_API_KEY }>
    <Elements>
      {children}
    </Elements>
  </StripeProvider>;

export default Stripe;



// WEBPACK FOOTER //
// ./app/components/shared/stripe/Stripe.jsx